import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Grab = createReactComponent("Grab", ["svg", defaultAttributes, [["path", {
  d: "M18 11.5V9a2 2 0 00-2-2v0a2 2 0 00-2 2v1.4",
  key: "1oq2lj"
}], ["path", {
  d: "M14 10V8a2 2 0 00-2-2v0a2 2 0 00-2 2v2",
  key: "1ywd9e"
}], ["path", {
  d: "M10 9.9V9a2 2 0 00-2-2v0a2 2 0 00-2 2v5",
  key: "xm2yqs"
}], ["path", {
  d: "M6 14v0a2 2 0 00-2-2v0a2 2 0 00-2 2v0",
  key: "sovcyc"
}], ["path", {
  d: "M18 11v0a2 2 0 114 0v3a8 8 0 01-8 8h-4a8 8 0 01-8-8 2 2 0 114 0",
  key: "16u0ve"
}]]]);
export default Grab;